import React, {useEffect, useState} from "react";
import axiosInstance from "../../utils/axiosInstance";
import {useNavigate, useParams} from "react-router-dom";
import {IoArrowBackSharp} from "react-icons/io5";

const EditAdditionalPrice = () => {
    const {id} = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        column: "ecu",
        value: "",
        credits: "",
        rule: "",
    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAdditionalPrice = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get(`/additional-prices/${id}`);
                const priceData = response.data;

                setFormData({
                    column: priceData.column || "ecu",
                    value: priceData.value || "",
                    credits: priceData.credits?.toString() || "",
                    rule: priceData.rule || "",
                });
            } catch (err) {
                setError("Failed to load additional price.");
            } finally {
                setLoading(false);
            }
        };

        fetchAdditionalPrice();
    }, [id]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await axiosInstance.put(`/additional-prices/${id}`, {
                column: formData.column,
                value: formData.value,
                credits: parseFloat(formData.credits),
                rule: formData.rule,
            });
            navigate("/admin/additional-prices");
        } catch (err) {
            setError("Failed to update additional price. Please try again.");
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-6">
            <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
                <button
                    onClick={() => window.history.back()}
                    className="rounded-full hover:bg-gray-200 transition-all mr-2"
                >
                    <IoArrowBackSharp size={24}/>
                </button>
                Edit Additional Price
            </h3>

            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
                {/* Column */}
                <div className="mb-4">
                    <label htmlFor="column" className="block text-gray-700 font-semibold mb-2">
                        Column
                    </label>
                    <select
                        id="column"
                        name="column"
                        value={formData.column}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        required
                    >
                        <option value="">Select column</option>
                        <option value="ecu">ecu</option>
                    </select>
                </div>

                {/* Value */}
                <div className="mb-4">
                    <label htmlFor="value" className="block text-gray-700 font-semibold mb-2">
                        Value
                    </label>
                    <input
                        type="text"
                        id="value"
                        name="value"
                        value={formData.value}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="e.g. edc16p"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label htmlFor="price" className="block text-gray-700 font-semibold mb-2">
                        Price
                    </label>
                    <input
                        type="number"
                        id="credits"
                        name="credits"
                        value={formData.credits}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="rule"
                        className="block text-gray-700 font-semibold mb-2"
                    >
                        Rule
                    </label>
                    <select
                        id="rule"
                        name="rule"
                        value={formData.rule}
                        onChange={handleChange}
                        className="w-full p-2 border border-gray-300 rounded-md"
                        required
                    >
                        <option value="">Select rule</option>
                        <option value="CONTAINS">CONTAINS</option>
                        <option value="STARTS_WITH">STARTS WITH</option>
                        <option value="EXACT_MATCH">EXACT MATCH</option>
                    </select>
                </div>

                {/* Error */}
                {error && <p className="text-red-500 mb-4">{error}</p>}

                {/* Submit */}
                <div className="flex justify-end">
                    <button
                        type="submit"
                        className={`px-4 py-2 text-white rounded-md ${
                            loading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"
                        }`}
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Update Additional Price"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default EditAdditionalPrice;